export const PUBLISHER = {
  name: "Lantro Music",
  // url: "https://www.lantromusic.be",
  // email: "info@lantromusic.be",
}